import GuestControlStrategy from "@/strategies/guestcontrol";
import ThirdPartyStrategy from "@/strategies/thirdparty";
import { ApiClient } from "zoox-infra";

export default class StrategyManager {
  constructor() {
    this.strategies = {
      0: "GuestControl",
      1: "ThirdParty"
    };
    this._strategy = null;
    this.apiClient = new ApiClient();
  }

  startLoading() {
    const store = this.apiClient.getStore();
    const event = { showLoading: true };
    store.commit("loader/START_LOADING", event);
  }

  finishLoading() {
    const store = this.apiClient.getStore();
    const event = { showLoading: true };
    store.commit("loader/FINISH_LOADING", event);
  }

  async setStrategy(strategy) {
    this.startLoading();
    if (this.strategies[strategy] === "GuestControl") {
      this._strategy = new GuestControlStrategy();
    }

    if (this.strategies[strategy] === "ThirdParty") {
      this._strategy = new ThirdPartyStrategy();
    }
  }

  async redirect(reservation, guest) {
    await this._strategy.redirect(reservation, guest);
    this.finishLoading();
  }

  async redirectWalkIn(companyId) {
    await this._strategy.redirectWalkIn(companyId);
    this.finishLoading();
  }
}
